import { combineReducers } from 'redux';

const popupWindowInitialState = {
  loadStatus: 0,
  saveStatus: 0,
  list: null,
};

const payNoticeInitialState ={
  loadStatus: 0,
  saveStatus: 0,
  list: null,
}

function popupWindowReducer(state = popupWindowInitialState, action) {
  switch (action.type) {
    case 'LOAD_POPUP_WINDOW_COMPLETION': {
      const { data, client } = action;

      return {
        ...state,
        loadStatus: 2,
        list: data.listData
          .filter(item => item.type !== 0 && item.client === client),
      };
    }

    case 'READ_POPUP_CONTENT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'READ_POPUP_CONTENT_COMPELTION': {
      const { error } = action;

      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }
      return {
        ...state,
        saveStatus: 2,
      };
    }

    case 'SHIFT_POPUP_WINDOW': {
      if (!state.list) {
        return state;
      }

      return {
        ...state,
        list: state.list.slice(1),
      };
    }

    default:
      return state;
  }
}

function payNoticeReducer(state = payNoticeInitialState, action) {
  switch (action.type) {
    case 'LOAD_PAY_NOTICE_COMPLETION': {
      const { data, client } = action;

      return {
        ...state,
        loadStatus: 2,
        list: data.filter(item => item.client === client),
      };
    }

    case 'READ_PAY_NOTICE_CONTENT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'READ_PAY_NOTICE_CONTENT_COMPELTION': {
      const { error } = action;

      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }
      return {
        ...state,
        saveStatus: 2,
      };
    }

    case 'SHIFT_PAY_NOTICE': {
      if (!state.list) {
        return state;
      }

      return {
        ...state,
        list: state.list.slice(1),
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  popupWindow: popupWindowReducer,
  payNotice: payNoticeReducer,
});
